import { c as _c } from "react/compiler-runtime";
import { LayoutGrid, MessageSquareQuote, ShieldCheck, Sparkles } from "lucide-react";
import { SecGlyph } from "@/features/home-v2/ornament";
import DeckImage from "../DeckImage";
import type { DetailModel } from "../model";

/**
 * THE SIDE OF THE CONVERSATION — what the empty half of the comments tab
 * was for: whose collection this talk is about (logo, name, maker), what a
 * good comment here looks like, and the way back to the works. Pinned beside
 * the thread on a wide screen; under it on a phone.
 */
export default function CommentsAside(t0) {
  const $ = _c(35);
  const {
    name,
    logo,
    creator,
    isFa,
    onWorks
  } = t0;
  let t1;
  if ($[0] !== isFa) {
    t1 = isFa ? [{
      icon: <Sparkles aria-hidden={true} />,
      text: "\u0627\u0632 \u062A\u062C\u0631\u0628\u0647\u200C\u062A\u0627\u0646 \u0628\u0627 \u0622\u062B\u0627\u0631 \u0627\u06CC\u0646 \u06A9\u0627\u0644\u06A9\u0634\u0646 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F\u061B \u06A9\u062F\u0627\u0645 \u0627\u062B\u0631 \u0648 \u0686\u0631\u0627."
    }, {
      icon: <MessageSquareQuote aria-hidden={true} />,
      text: "\u0627\u0645\u062A\u06CC\u0627\u0632 \u0633\u062A\u0627\u0631\u0647\u200C\u0627\u06CC \u0628\u0647 \u062F\u06CC\u06AF\u0631\u0627\u0646 \u06A9\u0645\u06A9 \u0645\u06CC\u200C\u06A9\u0646\u062F \u0633\u0631\u06CC\u0639\u200C\u062A\u0631 \u062A\u0635\u0645\u06CC\u0645 \u0628\u06AF\u06CC\u0631\u0646\u062F."
    }, {
      icon: <ShieldCheck aria-hidden={true} />,
      text: "\u0647\u0631\u06AF\u0632 \u0639\u0628\u0627\u0631\u062A \u0628\u0627\u0632\u06CC\u0627\u0628\u06CC \u06CC\u0627 \u06A9\u0644\u06CC\u062F \u062E\u0635\u0648\u0635\u06CC \u06A9\u06CC\u0641 \u067E\u0648\u0644 \u0631\u0627 \u062C\u0627\u06CC\u06CC \u0646\u0646\u0648\u06CC\u0633\u06CC\u062F."
    }] : [{
      icon: <Sparkles aria-hidden={true} />,
      text: "Write about the works themselves \u2014 which one, and why."
    }, {
      icon: <MessageSquareQuote aria-hidden={true} />,
      text: "A star rating helps others decide faster."
    }, {
      icon: <ShieldCheck aria-hidden={true} />,
      text: "Never post a wallet's recovery phrase or private key."
    }];
    $[0] = isFa;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tips = t1;
  const t2 = isFa ? "\u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u0627\u06CC\u0646 \u06AF\u0641\u062A\u200C\u0648\u06AF\u0648" : "About this conversation";
  let t3;
  if ($[2] !== name) {
    t3 = name.charAt(0);
    $[2] = name;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span>{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== logo || $[7] !== t4) {
    t5 = <span className="vt-talk-logo"><DeckImage src={logo} alt="" sizes="48px" fallback={t4} /></span>;
    $[6] = logo;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== name) {
    t6 = <b>{name}</b>;
    $[9] = name;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== creator || $[12] !== isFa) {
    t7 = creator ? <small>{isFa ? `اثر ${creator.name}` : `by ${creator.name}`}</small> : null;
    $[11] = creator;
    $[12] = isFa;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <span className="vt-talk-name">{t6}{t7}</span>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t8) {
    t9 = <div className="vt-talk-who">{t5}{t8}</div>;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SecGlyph className="vt-glyph" />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = isFa ? "\u06CC\u06A9 \u062F\u06CC\u062F\u06AF\u0627\u0647 \u062E\u0648\u0628" : "A good comment";
  let t12;
  if ($[21] !== t11) {
    t12 = <p className="vt-talk-h">{t10}{t11}</p>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== tips) {
    t13 = <ul className="vt-talk-tips">{tips.map(_temp)}</ul>;
    $[23] = tips;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <LayoutGrid aria-hidden={true} />;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = isFa ? "\u062F\u06CC\u062F\u0646 \u0622\u062B\u0627\u0631 \u0627\u06CC\u0646 \u06A9\u0627\u0644\u06A9\u0634\u0646" : "See this collection's works";
  let t16;
  if ($[26] !== onWorks || $[27] !== t15) {
    t16 = <button type="button" className="v2-btn v2-btn--ghost v2-btn--sm v2-focus vt-talk-go" onClick={onWorks}>{t14}{t15}</button>;
    $[26] = onWorks;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t16 || $[32] !== t2 || $[33] !== t9) {
    t17 = <aside className="vt-talk" aria-label={t2}>{t9}{t12}{t13}{t16}</aside>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t16;
    $[32] = t2;
    $[33] = t9;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
}
function _temp(tip, i) {
  return <li key={i}>{tip.icon}<span>{tip.text}</span></li>;
}